module.exports = __webpack_public_path__ + "static/media/concierge-bell.70b6fc47.svg";